import api from './../helpers/api'

class SettingsService {

    get_settings() {
        return api.get('/get_settings').then(r => r.data)
    }

    change_settings(formData) {
        return api.post('/update_settings', formData).then(r => r.data)
    }

    update_loyalty_settings(earnRate, pointValue) {
        return api.post('/update_loyalty_settings', {
            loyalty_earn_rate:   earnRate,
            loyalty_point_value: pointValue,
        })
    }

    // Taxes
    get_taxes() {
        return api.get('/get_taxes')
    }

    create_tax(tax) {
        return api.post('/create_tax', {
            name:       tax.name,
            percentage: tax.percentage,
            is_default: tax.is_default ? 1 : 0,
        })
    }

    update_tax(id, tax) {
        return api.post(`/update_tax/${id}`, {
            name:       tax.name,
            percentage: tax.percentage,
            is_default: tax.is_default ? 1 : 0,
        })
    }

    delete_tax(id) {
        return api.post(`/delete_tax/${id}`)
    }

    // Units
    get_units() {
        return api.get('/get_units')
    }

    create_unit(unit) {
        return api.post('/create_unit', {
            name:       unit.name,
            short_name: unit.short_name,
        })
    }

    update_unit(id, unit) {
        return api.post(`/update_unit/${id}`, {
            name:       unit.name,
            short_name: unit.short_name,
        })
    }

    delete_unit(id) {
        return api.post(`/delete_unit/${id}`)
    }

    // Payment Methods
    get_payment_methods() {
        return api.get('/payment_methods')
    }

    create_payment_method(data) {
        return api.post('/payment_methods', data)
    }

    update_payment_method(id, data) {
        return api.put(`/payment_methods/${id}`, data)
    }

    delete_payment_method(id) {
        return api.delete(`/payment_methods/${id}`)
    }

    toggle_payment_method(id) {
        return api.post(`/payment_methods/${id}/toggle`)
    }
}

export default new SettingsService
